// extracted by mini-css-extract-plugin
module.exports = {"form":"FormContainer_form__3Ire9","formCompleted":"FormContainer_formCompleted__iMA7w","complete":"FormContainer_complete__1z-vI","completeP":"FormContainer_completeP__1WkI9"};